// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentHeader_wrapper__qRBTx","title":"ContentHeader_title__F13jN"};